/** Parse comma-separated sys_role string */
export function parseSysRoles(sysRole) {
  if (!sysRole || typeof sysRole !== 'string') return []
  const seen = new Set()
  const out = []
  for (const part of sysRole.split(',')) {
    const name = part.trim()
    if (!name) continue
    const key = name.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    out.push(name)
  }
  return out
}

/** Whether sysRole contains roleName (comma-separated, case-insensitive) */
export function hasSysRole(sysRole, roleName) {
  if (!roleName) return false
  const target = String(roleName).trim().toLowerCase()
  return parseSysRoles(sysRole).some((r) => r.toLowerCase() === target)
}

export function hasAnySysRole(sysRole, roleNames) {
  return roleNames.some((name) => hasSysRole(sysRole, name))
}

export function isSystemAdmin(sysRole) {
  return hasAnySysRole(sysRole, ['admin', 'superadmin'])
}

export function isSuperAdmin(sysRole) {
  return hasSysRole(sysRole, 'superadmin')
}

export const BUILTIN_ROLE_NAMES = ['superadmin', 'admin', 'member', 'user']

export function isBuiltinRoleName(name) {
  if (!name) return false
  const target = String(name).trim().toLowerCase()
  return BUILTIN_ROLE_NAMES.some((r) => r === target)
}
